export default __webpack_public_path__ + "static/media/web-allina-icon-01.94aa1b2e.svg";